import { Box, Divider, Grid, Popover, Typography, Avatar as MuiAvatar, Button } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

const Avatar = styled(MuiAvatar)(({}) => ({
    "&.MuiAvatar-root": {
        svg: {
            marginRight: 0,
        },
    },
}));

const AvatarText = (value) => {
    const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/;

    return value?.match(emojiRegex) ? value.substring(0, 2) : value?.substring(0, value?.length === 2 ? 2 : 1);
};

const UserProfile = (props) => {
    return (
        <>
            {(props.profileImageUrl !== null && (
                <Avatar
                    style={{
                        width: props.size,
                        height: props.size,
                        fontSize: 18,
                        mt: "5px",
                    }}
                    src={props.profileImageUrl}
                />
            )) || (
                <Avatar
                    style={{
                        width: props.size,
                        height: props.size,
                        fontSize: 16,
                        lineHeight: `40px`,
                        color: `white`,
                        mt: "5px",
                    }}
                >
                    {AvatarText(props.firstName)}
                </Avatar>
            )}
        </>
    );
};

// NOTE:: 현우님! 말줄임 되는 버튼 여기 있습니다! maxWidth 값으로로 너비 조절 하시면 됩니다!
export const UserDetailButton = ({ userName, maxWidth, onClick, ...rest }) => {
    return (
        <Button
            variant={"text"}
            size={"small"}
            color={userName === "Me" ? "success" : "greySecondary"}
            onClick={onClick}
            sx={{
                maxWidth: maxWidth ?? 100,
                "> span[class^=css]": {
                    display: `inline-block`,
                    maxWidth: `inherit`,
                    overflow: `hidden`,
                    textOverflow: `ellipsis`,
                    whiteSpace: `nowrap`,
                },
            }}
            {...rest}
        >
            {userName}
        </Button>
    );
};
const UserDetailPopper = ({ handleUserProfileClose, userProfileAnchorEl, openUserProfile, userProfileData, id }) => {
    const { t } = useTranslation();

    return (
        <Popover
            id={id}
            open={openUserProfile}
            anchorEl={userProfileAnchorEl}
            onClose={handleUserProfileClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
        >
            <Box
                sx={{
                    px: theme.spacing(2),
                    py: theme.spacing(1.5),
                    width: `280px`,
                    border: `1px solid ${theme.palette.greySecondary[100]}`,
                    boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.12)`,
                    borderRadius: theme.spacing(0.25),
                }}
            >
                <Grid container flexDirection={"row"} gap={theme.spacing(1.5)}>
                    <Grid item flex={0}>
                        <UserProfile size={40} />
                    </Grid>
                    <Grid item flex={1}>
                        <Grid container flexDirection={`column`}>
                            <Grid item>
                                <Typography variant={"body1_500"} color={theme.palette.greySecondary.main}>
                                    {userProfileData?.name ?? "-"}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant={"body1_400"} color={theme.palette.greySecondary[600]}>
                                    {userProfileData?.username ?? "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {(userProfileData?.displayName || userProfileData?.phoneNumber) && (
                    <>
                        <Divider
                            sx={{
                                marginTop: 2,
                                marginBottom: 2,
                                borderColor: theme.palette.greySecondary[100],
                                backgroundColor: theme.palette.greySecondary[100],
                            }}
                        />
                        <Grid
                            container
                            flexDirection={`column`}
                            wrap={`nowrap`}
                            gap={`16px`}
                            sx={{ overflow: `overlay` }}
                        >
                            {userProfileData?.displayName && (
                                <Grid container flexDirection={"column"} gap={theme.spacing(1)}>
                                    <Grid item>
                                        <Typography variant={"body3_400"} color={theme.palette.greySecondary[600]}>
                                            {t(`common::label::Display Name`, `Display Name`)}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant={"body1_400"} color={theme.palette.greySecondary.main}>
                                            {userProfileData?.displayName}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {userProfileData?.phoneNumber && (
                                <Grid container flexDirection={"column"} gap={theme.spacing(1)}>
                                    <Grid item>
                                        <Typography variant={"body3_400"} color={theme.palette.greySecondary[600]}>
                                            {t(`common::label::Phone Number`, `Phone Number`)}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant={"body1_400"} color={theme.palette.greySecondary.main}>
                                            {userProfileData?.phoneNumber}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </>
                )}
            </Box>
        </Popover>
    );
};

export default UserDetailPopper;
